// You can create a dApp definition in the dev console at https://stokenet-console.radixdlt.com/dapp-metadata

import { RadixNetwork } from "@radixdlt/radix-dapp-toolkit";

// Determine which network to use
// Set REACT_APP_NETWORK=mainnet in your production environment variables to switch to Mainnet
const IS_MAINNET = process.env.REACT_APP_NETWORK === 'mainnet';

const MAINNET_CONFIG = {
  dAppDefinitionAddress: "account_rdx129dwcgh35n829n54uaf76sjh0vmzrwnsnyt57l7ud40utwh8pc5lvt",
  RADIX_NETWORK: RadixNetwork.Mainnet,
  RADIX_TOKEN_RESOURCE_ADDRESS: "resource_rdx1tknxxxxxxxxxradxrdxxxxxxxxx009923554798xxxxxxxxxradxrd",
  RADIX_API_GATEWAY_URL: "https://mainnet.radixdlt.com",
  REDDICKS_DEX_ROUTER_COMPONENT: "component_rdx1czlszr76d2wrc28uslyqddp6cgelx6y4rf2a80056wwd4grx9u09xy",
  DCKSLAP_RESOURCE_ADDRESS: "resource_rdx1t4yllduv4eefjj4cksvq6na2lpkptyvurkdhwx2fpu4trcvsamukmp",
  DCKSLAP_USER_BADGE_RESOURCE_ADDRESS: "resource_rdx1ngvcjjnea4c897000pznkvelej3sur4gu94jcdqsntyzux2z5x6jk9",
  DCKSLAP_COMPONENT_ADDRESS: "component_rdx1cr7hhx74ekdqwgqhqx7dp4eja74l72ke86w2q9w4cvnvte2e4mpjfw",
  REDDICKS_RESSOURCE_ADDRESS: "resource_rdx1t42hpqvsk4t42l6aw09hwphd2axvetp6gvas9ztue0p30f4hzdwxrp",
  GBOF_RESOURCE_ADDRESS: "resource_rdx1t40vqvcsljc2dhq9tfnjg98de056me5l676zeyf9694tztacnt2utu",
  CANDY_MACHINE_COMPONENT_ADDRESS: "component_rdx1czsxjjmu7mzkydnwpzhmlu290nndp7y0xxd2mfuj2zpq7pyyc7vxn5",
  CANDY_MACHINE_BOT_BADGE_ADDRESS: "resource_rdx1t5n8rjswkgx9er4qke4n6h9evz2tt7h0a520n23w5v68fpdfu9d9qd",
  CANDY_MACHINE_INTERNAL_USERS_KEY_VALUE_STORE: "internal_keyvaluestore_rdx1kqau7w3dmaeps54wyt0k9kj2tv5058ye064zl3kgdag4uwf3kde26f",
  CANDY_MACHINE_CANDIES_RESOURCE_ADDRESS: {
    // CocoaPop
    "resource_rdx1thw63hauuq5n9fpd07wsgj3s0kmmhzc8q94dc0hfwxvq44jt4adv5s": {
      name: "CocoaPop",
      rarity: "Street"
    },
    "resource_rdx1t5q3gl6va2wrhe6uvjmucrzy64ul5xw2pj2pdv2dwvz3d3sh0zj2wl": {
      name: "CocoaPop",
      rarity: "Juiced"
    },
    "resource_rdx1tkyywu688vxzu7gaje6zudqcfwgk47avkurryndny0rtxvurp44luh": {
      name: "CocoaPop",
      rarity: "Cracked"
    },
    "resource_rdx1t49gmj9q242kueccexvgpaje8tfqqn2mx4mdkkz8vjpux7yukq0eyu": {
      name: "CocoaPop",
      rarity: "Unhinged"
    },
    "resource_rdx1t4mha7awhvcgwgp8pv2xkgvpn0qew8kx6ewqwlskt5dvhklv7gwmjm": {
      name: "CocoaPop",
      rarity: "GoldMember"
    },
    "resource_rdx1t5egscrcp9n8x4nepe7fzy33hq46munvrah2gsfqf3q7hpyfdwwprm": {
      name: "CocoaPop",
      rarity: "MythDck"
    },

    // SlapTaffy
    "resource_rdx1tk2pe4s6xyqz083r8ue3926z7aynp3ddnfuy4h85lcc80v2e8srtgv": {
      name: "SlapTaffy",
      rarity: "Street"
    },
    "resource_rdx1t5p9jvf75m4jc6r8clddlypt65nye08a0l6qmm30zej53acz0k6g07": {
      name: "SlapTaffy",
      rarity: "Juiced"
    },
    "resource_rdx1t4kgtgxur65pmv7fwtupf7alzh33w7t8hqdsdttr87hxmgngn8ggy4": {
      name: "SlapTaffy",
      rarity: "Cracked"
    },
    "resource_rdx1thz6g9fnuf99ah65qk2e32e2ttpzsty7kxklpef4wcc8lkgm2rqgkn": {
      name: "SlapTaffy",
      rarity: "Unhinged"
    },
    "resource_rdx1t5tm7zshw80r6ekmtd7nxdmgy68dk6686g6t3f89v02y749mfqef03": {
      name: "SlapTaffy",
      rarity: "GoldMember"
    },
    "resource_rdx1t4w96mgx546xwwnwdzcp8rhl2yhavj80k3k7meyepdf0gpgs6njx0a": {
      name: "SlapTaffy",
      rarity: "MythDck"
    },

    // NutPop
    "resource_rdx1t5zrxkaw3ngtf6a4zjv2gqaem60uzhkn4r4hx0ctyuxfpr2fkjhzr6": {
      name: "NutPop",
      rarity: "Street"
    },
    "resource_rdx1tk6me6y297039fh7wtautvuh5a0ddvurr69j8pcmejankruxn03apn": {
      name: "NutPop",
      rarity: "Juiced"
    },
    "resource_rdx1thgah2xz2h0wsug5mkhed5ugyuyz9tsx45nxyrpvvlrkftupplskhh": {
      name: "NutPop",
      rarity: "Cracked"
    },
    "resource_rdx1t47xx3rgn3qr8qyk6p0r835j85la8eclznuusy5yfry5ma3450fjve": {
      name: "NutPop",
      rarity: "Unhinged"
    },
    "resource_rdx1tk6pw7tm0rj6fee97v8pqxfpep3aczwwxynh54kwe7pns97px0dp2y": {
      name: "NutPop",
      rarity: "GoldMember"
    },
    "resource_rdx1thf6p69kzcdugpjuz5e6adtgulz2c5u3jx5n5d6tl9p5x986fh26s4": {
      name: "NutPop",
      rarity: "MythDck"
    },

    // ShaftBerry
    "resource_rdx1t4dwmfykk49fm98cvkutr0gscevdd6kfpgxyz4uq4z8ntg94fgksfd": {
      name: "ShaftBerry",
      rarity: "Street"
    },
    "resource_rdx1t4p7s947atlv05pf8lm64luqjae2rn4slqp7hd573239l6p0hlpctq": {
      name: "ShaftBerry",
      rarity: "Juiced"
    },
    "resource_rdx1t58gez65ydh2w3s8tlzra378xe44cf6g79jkpcctl83uzvc7hpwc7n": {
      name: "ShaftBerry",
      rarity: "Cracked"
    },
    "resource_rdx1t4txxdmad3xslnlshj93q7r7pz36lv9u3ljctpvgftmm34gpnkvx2k": {
      name: "ShaftBerry",
      rarity: "Unhinged"
    },
    "resource_rdx1t5c470yaxcgm3ps0td89amh3vtj448farkvle8r8pv9pg3hd0y626e": {
      name: "ShaftBerry",
      rarity: "GoldMember"
    },
    "resource_rdx1tksd5mj2d7qsumg8vkhp2rlt2yjd4697wqx8cu4qkm6squhv27jepg": {
      name: "ShaftBerry",
      rarity: "MythDck"
    }
  },
  // BatchCandyDispenser
  BATCH_CANDY_DISPENSER_COMPONENT_ADDRESS: "component_rdx1cqj5hm477s9rq3wrcprq03fyekreaxd5hr6e7p78pjwxc5jsnwvdtj",
  BATCH_DCKSLAP_PER_BATCH: 10,
  BATCH_REDDICKS_FEE_AMOUNT: "40",
  BATCH_XRD_FEE_AMOUNT: "10",
  CANDY_WRAPPER_COMPONENT_ADDRESS: "component_rdx1crne8cwkfdtfgkmh0s8yttsxxq5euy70d46rgqu388mhjj943wrryj",
  CANDY_WRAPPER_OWNER_BADGE_ADDRESS: "resource_rdx1tky9ccw2dj42qd2q60cz40gclu7m3z779zhnt768jmpzaah4j2zuf9",
  CANDY_WRAPPER_PAIRS: {
    // CocoaPop
    "resource_rdx1thw63hauuq5n9fpd07wsgj3s0kmmhzc8q94dc0hfwxvq44jt4adv5s": "resource_rdx1tkja03wcdzam5nplwr29x9kucqlxcrzq9qhdsjy6ej6wql20u2ckff",
    "resource_rdx1t5q3gl6va2wrhe6uvjmucrzy64ul5xw2pj2pdv2dwvz3d3sh0zj2wl": "resource_rdx1tkqephtu2z7ulheuvqgeazdg6r8pyd9eu02g4kusad76ps7ff3m4mq",
    "resource_rdx1tkyywu688vxzu7gaje6zudqcfwgk47avkurryndny0rtxvurp44luh": "resource_rdx1t45yrf8l4n0x2zxw5kmjg6jw7695cyvghcq7hmtcfyt43wvgj6pslj",
    "resource_rdx1t49gmj9q242kueccexvgpaje8tfqqn2mx4mdkkz8vjpux7yukq0eyu": "resource_rdx1t4wkxp0adju73v8he2aef55lm2crhcpu3dyw7hkpk8m62w4pnmk8x9",
    "resource_rdx1t4mha7awhvcgwgp8pv2xkgvpn0qew8kx6ewqwlskt5dvhklv7gwmjm": "resource_rdx1t4sfpxjkzxcn0kgqj5dl5t6tpm53e3tpjy2wlx2u44e75p08gsvgg0",
    "resource_rdx1t5egscrcp9n8x4nepe7fzy33hq46munvrah2gsfqf3q7hpyfdwwprm": "resource_rdx1th6sl48cmj56855qtw6fpu255xdgvsguhw7ys85kn7yrnlr0g6awv5",

    // SlapTaffy
    "resource_rdx1tk2pe4s6xyqz083r8ue3926z7aynp3ddnfuy4h85lcc80v2e8srtgv": "resource_rdx1tkjfx8tj6y5n3q0qwl2wv3fujhrmjxz8ac63mm8ps80te2r4d4jev4",
    "resource_rdx1t5p9jvf75m4jc6r8clddlypt65nye08a0l6qmm30zej53acz0k6g07": "resource_rdx1t4jefck2859xzgypvdfgpf9yfy5pt9wwthnrs6afnsju98r2tv0q28",
    "resource_rdx1t4kgtgxur65pmv7fwtupf7alzh33w7t8hqdsdttr87hxmgngn8ggy4": "resource_rdx1t5en2c6gf5lr9k049e4qtlqakqn4lle5csnmedw8849e6h0zc5sref",
    "resource_rdx1thz6g9fnuf99ah65qk2e32e2ttpzsty7kxklpef4wcc8lkgm2rqgkn": "resource_rdx1t48d8v5xxr48evgvpcj8hn28j70w77vsrsmlctdng0hel402lgr9yf",
    "resource_rdx1t5tm7zshw80r6ekmtd7nxdmgy68dk6686g6t3f89v02y749mfqef03": "resource_rdx1t573ufhhl6f7qsclrtjttkc6c0jxvslxcq8p54w2m8mqt32d95v7c9",
    "resource_rdx1t4w96mgx546xwwnwdzcp8rhl2yhavj80k3k7meyepdf0gpgs6njx0a": "resource_rdx1tkrw0n3vtwkw9f757heg2me5nklgjkpfakmy8x3pudyh86x00mq8yj",

    // NutPop
    "resource_rdx1t5zrxkaw3ngtf6a4zjv2gqaem60uzhkn4r4hx0ctyuxfpr2fkjhzr6": "resource_rdx1t4gdg8uwqjzgtl08sfzrep7vpyu5sufkhxf8n3hdp79qzvll968u6y",
    "resource_rdx1tk6me6y297039fh7wtautvuh5a0ddvurr69j8pcmejankruxn03apn": "resource_rdx1tkez96w06074y29kz0vydjzaytu5cr76tt0tj693zrvw6au2g89zkp",
    "resource_rdx1thgah2xz2h0wsug5mkhed5ugyuyz9tsx45nxyrpvvlrkftupplskhh": "resource_rdx1the62lwg0j9q2fey6xxk86jfj2cacph54f0763lmaknf4xpfavx5ar",
    "resource_rdx1t47xx3rgn3qr8qyk6p0r835j85la8eclznuusy5yfry5ma3450fjve": "resource_rdx1t5ru4qh0fahrpgmdrvwzfzdrssgu4avaxfsd0ppj3z5wjshwngg6sl",
    "resource_rdx1tk6pw7tm0rj6fee97v8pqxfpep3aczwwxynh54kwe7pns97px0dp2y": "resource_rdx1tkz20kw8u93fa06ls7t7jcmfr5k3xraduqw5w075c3k9rw8f94ns5v",
    "resource_rdx1thf6p69kzcdugpjuz5e6adtgulz2c5u3jx5n5d6tl9p5x986fh26s4": "resource_rdx1t4qnzhuxx4h977kwer4yhm4csus9pcp4k8dkpngnegfl2t5dyuuje5",

    // ShaftBerry
    "resource_rdx1t4dwmfykk49fm98cvkutr0gscevdd6kfpgxyz4uq4z8ntg94fgksfd": "resource_rdx1t4qklwp3d5r5aqlredczjtklsdgw35kuny0fpmrn8lmq4teah04jat",
    "resource_rdx1t4p7s947atlv05pf8lm64luqjae2rn4slqp7hd573239l6p0hlpctq": "resource_rdx1t4r7ft7zpqq88xz2e746adf7de0tm63txqddcxyt7xrl86dq40spd5",
    "resource_rdx1t58gez65ydh2w3s8tlzra378xe44cf6g79jkpcctl83uzvc7hpwc7n": "resource_rdx1th0jv8mywtfkk3tzqel0mltrtr7q0dvxvwm7j2ernzp7mftrygpme4",
    "resource_rdx1t4txxdmad3xslnlshj93q7r7pz36lv9u3ljctpvgftmm34gpnkvx2k": "resource_rdx1th08nx5ekcxz8yfp5cpq2pt3u9utqu6dyveprg8y5yyxyn4lrz7v0k",
    "resource_rdx1t5c470yaxcgm3ps0td89amh3vtj448farkvle8r8pv9pg3hd0y626e": "resource_rdx1t4gdn95xfd9flslzu9w604kp6uwahlqjhz4ec07z7d42a4mcy2lsk3",
    "resource_rdx1tksd5mj2d7qsumg8vkhp2rlt2yjd4697wqx8cu4qkm6squhv27jepg": "resource_rdx1t5cyl5gfhy6rvpl9pg86nfs0gavhyqz9d23xvk0ljw0fxwkpts42ps",
  },
};

const STOCKNET_CONFIG = {
  dAppDefinitionAddress: "account_tdx_2_128dneesv5tdamm2rtnh5m2av9r8ua6mtvf35gmnt4d8n3k695r2xsr",
  RADIX_NETWORK: RadixNetwork.Stokenet,
  RADIX_TOKEN_RESOURCE_ADDRESS: "resource_tdx_2_1tknxxxxxxxxxradxrdxxxxxxxxx009923554798xxxxxxxxxtfd2jc",
  RADIX_API_GATEWAY_URL: "https://stokenet.radixdlt.com",
  REDDICKS_DEX_ROUTER_COMPONENT: "",
  DCKSLAP_RESOURCE_ADDRESS: "resource_tdx_2_1t5d4nz9a52ykeyyh737c6828axuyjjgcf54ac98fwvy4m9xtc7070l",
  DCKSLAP_USER_BADGE_RESOURCE_ADDRESS: "resource_tdx_2_1nggks08p8sdtf0y5ztzs7dcfng9lfwf8dfgz0z4nd22pzttxwdwzpk",
  DCKSLAP_COMPONENT_ADDRESS: "component_tdx_2_1czjrpv9x88zpwf38daatyqfpnc7udd0y44pg29vzgh75ujvzfrnx5t",
  REDDICKS_RESSOURCE_ADDRESS: "resource_tdx_2_1tht50kccujaxx2r2eluc8kh02xqp76a7qehja6ewtlgc88xq9r8pda",
  GBOF_RESOURCE_ADDRESS: "resource_tdx_2_1t4aztvwpnp7xp850zlgf5ar6g7xt8fgc0tumsxxl6ushsnnzsux2wj",
  CANDY_MACHINE_COMPONENT_ADDRESS: "component_tdx_2_1cpdlkmtkv9muscsr2maums8u3vkxqmzzv0kmmuvuctcqfe65402nv7",
  CANDY_MACHINE_BOT_BADGE_ADDRESS: "resource_tdx_2_1th2tzqwvz4nkuezv635922jpe76nxuwga486cyzjyegktvm0er0ert",
  CANDY_MACHINE_INTERNAL_USERS_KEY_VALUE_STORE: "internal_keyvaluestore_tdx_2_1kq80940rqxluxmy3pmap20m0s8hydujsdajrx7tvr5jswmhjxh5e78",
  CANDY_MACHINE_CANDIES_RESOURCE_ADDRESS: {
    // CocoaPop
    "resource_tdx_2_1t4eth2ly4d5tsw6e9504w93t53352h5vh6quctre0desywxn4sdarx": {
      name: "CocoaPop",
      rarity: "Street"
    },
    "resource_tdx_2_1t5zfcjaferl55ph8ey39sspdl6v69xl9r2cts5agp3gnmwx6zczqr8": {
      name: "CocoaPop",
      rarity: "Juiced"
    },
    "resource_tdx_2_1t5u5c9ftm5tt4jf5csajgt4tvrxp2nsws0jjtcdmhxduxg597ec9uv": {
      name: "CocoaPop",
      rarity: "Cracked"
    },
    "resource_tdx_2_1t40ksr92382dkpuym6r6ctrekv7smsngx95cd6xjh7vyu55c9q3l0u": {
      name: "CocoaPop",
      rarity: "Unhinged"
    },
    "resource_tdx_2_1tksz6pwj9nk7rzdc8jrzgneuwp639xdkxas8eljzc6grpqm2sa4trt": {
      name: "CocoaPop",
      rarity: "GoldMember"
    },
    "resource_tdx_2_1t4rmj6mewa69ehgz427aj8yx3w6qz92cju8jp92ytctu0e7ujevt54": {
      name: "CocoaPop",
      rarity: "MythDck"
    },

    // SlapTaffy
    "resource_tdx_2_1tk9fpx6qjds6rger5w30czv4v3nufe72d96lgq08se2nwzczdlgmu7": {
      name: "SlapTaffy",
      rarity: "Street"
    },
    "resource_tdx_2_1t5qrtcvwfs3mgmfzhls4rhp4l4snd7mj323a5gptjsllqjm2wekumn": {
      name: "SlapTaffy",
      rarity: "Juiced"
    },
    "resource_tdx_2_1t5w88mvuwgvm8w8ts7ngss753d37y7t5qyuytagkz7ws2puk3uasur": {
      name: "SlapTaffy",
      rarity: "Cracked"
    },
    "resource_tdx_2_1t446czqrzan2wtlvyqrzkudad8jtmeglyn64e0yfugspzj2u7d3587": {
      name: "SlapTaffy",
      rarity: "Unhinged"
    },
    "resource_tdx_2_1tkyzvr7sfcr9j02cmfc9syecrrl5e0897dvtu80m6lfl76r6r2u5mf": {
      name: "SlapTaffy",
      rarity: "GoldMember"
    },
    "resource_tdx_2_1t58agefh3u79xy4zafa9ydrz2z5z67k2eefr0w6838cjh650mc9kqc": {
      name: "SlapTaffy",
      rarity: "MythDck"
    },

    // NutPop
    "resource_tdx_2_1t5k5kmaet0nefh2fl6txdnf6cmqsgra4ddhz2fyacelhza3gsn8x74": {
      name: "NutPop",
      rarity: "Street"
    },
    "resource_tdx_2_1t45ytzqppk4fx3tns83lrmfeuaa662m3uyytt08m42nmgaftvd93xu": {
      name: "NutPop",
      rarity: "Juiced"
    },
    "resource_tdx_2_1tkx5ej9qhu6tdxd57efuv0a9j5zsghy7uyakrc8nmj9clw5eksq8tl": {
      name: "NutPop",
      rarity: "Cracked"
    },
    "resource_tdx_2_1thrv022y88n20zjpd5k9crjy4h6qempxdwvwc80l09w3d9d23hujau": {
      name: "NutPop",
      rarity: "Unhinged"
    },
    "resource_tdx_2_1tk4vcr7dkzcuj658cjxlm6hsj0s3gsnmawklfh2gqvsek038y8hjuj": {
      name: "NutPop",
      rarity: "GoldMember"
    },
    "resource_tdx_2_1t5g4znkfs3ytn6urfzjpss2ptxr9pvjjr60trw96wzxkdx07z9fuqy": {
      name: "NutPop",
      rarity: "MythDck"
    },

    // ShaftBerry
    "resource_tdx_2_1thnhlf0eh0w943jzah72plxlvk3vu5w63aa262eytcymjvg32lsmlk": {
      name: "ShaftBerry",
      rarity: "Street"
    },
    "resource_tdx_2_1t4hu76t43476x2tjtqxc6p4tt65lyw39fzgj5p2pwxd6rxncclhz3k": {
      name: "ShaftBerry",
      rarity: "Juiced"
    },
    "resource_tdx_2_1tkl7gqg9exl9zcx5cgazv8l2khrm27kv6fw2yhw4d4j04zvh5jeddd": {
      name: "ShaftBerry",
      rarity: "Cracked"
    },
    "resource_tdx_2_1th0gdzr2sk7xstvu3rzyakwe2pyydegvz5hmd85pxhvcrx44kada8h": {
      name: "ShaftBerry",
      rarity: "Unhinged"
    },
    "resource_tdx_2_1tkx0hyn6q6hj0pwjp6e4yytz5v2mh57rf6842zh6ahtycr2te79tnz": {
      name: "ShaftBerry",
      rarity: "GoldMember"
    },
    "resource_tdx_2_1tkr0r40rxmt98nlm3g0vxfxz2csc0h7gu40y3465nf4pje49aygux9": {
      name: "ShaftBerry",
      rarity: "MythDck"
    }
  },
  // BatchCandyDispenser
  BATCH_CANDY_DISPENSER_COMPONENT_ADDRESS: "component_tdx_2_1cpz83pzaxmf2chgacr4mfuqhwkhdzzcrayn6vk6q83ad3fyaemsa0r",
  BATCH_DCKSLAP_PER_BATCH: 10,
  BATCH_REDDICKS_FEE_AMOUNT: "40",
  BATCH_XRD_FEE_AMOUNT: "10",
  CANDY_WRAPPER_COMPONENT_ADDRESS: "component_tdx_2_1cpfr2pudftxr5h20axj94zku5wrk95pc2js402y38ytqrdyjvtnjn9",
  CANDY_WRAPPER_OWNER_BADGE_ADDRESS: "resource_tdx_2_1t4xz7u62atuncj8xal7505mcct3t62vlhrcxzamw3lalhxa0qjv7hn",
  CANDY_WRAPPER_PAIRS: {
    // ── CocoaPop ──
    "resource_tdx_2_1t4eth2ly4d5tsw6e9504w93t53352h5vh6quctre0desywxn4sdarx": "WRAPPED_COCOAPOP_STREET_ADDRESS",
    "resource_tdx_2_1t5zfcjaferl55ph8ey39sspdl6v69xl9r2cts5agp3gnmwx6zczqr8": "WRAPPED_COCOAPOP_JUICED_ADDRESS",
    "resource_tdx_2_1t5u5c9ftm5tt4jf5csajgt4tvrxp2nsws0jjtcdmhxduxg597ec9uv": "WRAPPED_COCOAPOP_CRACKED_ADDRESS",
    "resource_tdx_2_1t40ksr92382dkpuym6r6ctrekv7smsngx95cd6xjh7vyu55c9q3l0u": "WRAPPED_COCOAPOP_UNHINGED_ADDRESS",
    "resource_tdx_2_1tksz6pwj9nk7rzdc8jrzgneuwp639xdkxas8eljzc6grpqm2sa4trt": "WRAPPED_COCOAPOP_GOLDMEMBER_ADDRESS",
    "resource_tdx_2_1t4rmj6mewa69ehgz427aj8yx3w6qz92cju8jp92ytctu0e7ujevt54": "WRAPPED_COCOAPOP_MYTHDCK_ADDRESS",

    // ── SlapTaffy ──
    "resource_tdx_2_1tk9fpx6qjds6rger5w30czv4v3nufe72d96lgq08se2nwzczdlgmu7": "WRAPPED_SLAPTAFFY_STREET_ADDRESS",
    "resource_tdx_2_1t5qrtcvwfs3mgmfzhls4rhp4l4snd7mj323a5gptjsllqjm2wekumn": "WRAPPED_SLAPTAFFY_JUICED_ADDRESS",
    "resource_tdx_2_1t5w88mvuwgvm8w8ts7ngss753d37y7t5qyuytagkz7ws2puk3uasur": "WRAPPED_SLAPTAFFY_CRACKED_ADDRESS",
    "resource_tdx_2_1t446czqrzan2wtlvyqrzkudad8jtmeglyn64e0yfugspzj2u7d3587": "WRAPPED_SLAPTAFFY_UNHINGED_ADDRESS",
    "resource_tdx_2_1tkyzvr7sfcr9j02cmfc9syecrrl5e0897dvtu80m6lfl76r6r2u5mf": "WRAPPED_SLAPTAFFY_GOLDMEMBER_ADDRESS",
    "resource_tdx_2_1t58agefh3u79xy4zafa9ydrz2z5z67k2eefr0w6838cjh650mc9kqc": "resource_tdx_2_1t5eyy8ft694d57ak98ae82wyk2yvqrc0rws2cfsgeup8nz0tgvjqly",

    // ── NutPop ──
    "resource_tdx_2_1t5k5kmaet0nefh2fl6txdnf6cmqsgra4ddhz2fyacelhza3gsn8x74": "WRAPPED_NUTPOP_STREET_ADDRESS",
    "resource_tdx_2_1t45ytzqppk4fx3tns83lrmfeuaa662m3uyytt08m42nmgaftvd93xu": "WRAPPED_NUTPOP_JUICED_ADDRESS",
    "resource_tdx_2_1tkx5ej9qhu6tdxd57efuv0a9j5zsghy7uyakrc8nmj9clw5eksq8tl": "WRAPPED_NUTPOP_CRACKED_ADDRESS",
    "resource_tdx_2_1thrv022y88n20zjpd5k9crjy4h6qempxdwvwc80l09w3d9d23hujau": "WRAPPED_NUTPOP_UNHINGED_ADDRESS",
    "resource_tdx_2_1tk4vcr7dkzcuj658cjxlm6hsj0s3gsnmawklfh2gqvsek038y8hjuj": "WRAPPED_NUTPOP_GOLDMEMBER_ADDRESS",
    "resource_tdx_2_1t5g4znkfs3ytn6urfzjpss2ptxr9pvjjr60trw96wzxkdx07z9fuqy": "WRAPPED_NUTPOP_MYTHDCK_ADDRESS",

    // ── ShaftBerry ──
    "resource_tdx_2_1thnhlf0eh0w943jzah72plxlvk3vu5w63aa262eytcymjvg32lsmlk": "WRAPPED_SHAFTBERRY_STREET_ADDRESS",
    "resource_tdx_2_1t4hu76t43476x2tjtqxc6p4tt65lyw39fzgj5p2pwxd6rxncclhz3k": "WRAPPED_SHAFTBERRY_JUICED_ADDRESS",
    "resource_tdx_2_1tkl7gqg9exl9zcx5cgazv8l2khrm27kv6fw2yhw4d4j04zvh5jeddd": "WRAPPED_SHAFTBERRY_CRACKED_ADDRESS",
    "resource_tdx_2_1th0gdzr2sk7xstvu3rzyakwe2pyydegvz5hmd85pxhvcrx44kada8h": "WRAPPED_SHAFTBERRY_UNHINGED_ADDRESS",
    "resource_tdx_2_1tkx0hyn6q6hj0pwjp6e4yytz5v2mh57rf6842zh6ahtycr2te79tnz": "WRAPPED_SHAFTBERRY_GOLDMEMBER_ADDRESS",
    "resource_tdx_2_1tkr0r40rxmt98nlm3g0vxfxz2csc0h7gu40y3465nf4pje49aygux9": "WRAPPED_SHAFTBERRY_MYTHDCK_ADDRESS",
  },
};

const CONFIG = IS_MAINNET ? MAINNET_CONFIG : STOCKNET_CONFIG;

export const dAppDefinitionAddress = CONFIG.dAppDefinitionAddress;
export const RADIX_NETWORK = CONFIG.RADIX_NETWORK;
export const RADIX_TOKEN_RESOURCE_ADDRESS = CONFIG.RADIX_TOKEN_RESOURCE_ADDRESS;
export const RADIX_API_GATEWAY_URL = CONFIG.RADIX_API_GATEWAY_URL;
export const REDDICKS_DEX_ROUTER_COMPONENT = CONFIG.REDDICKS_DEX_ROUTER_COMPONENT;
export const DCKSLAP_RESOURCE_ADDRESS = CONFIG.DCKSLAP_RESOURCE_ADDRESS;
export const DCKSLAP_USER_BADGE_RESOURCE_ADDRESS = CONFIG.DCKSLAP_USER_BADGE_RESOURCE_ADDRESS;
export const DCKSLAP_COMPONENT_ADDRESS = CONFIG.DCKSLAP_COMPONENT_ADDRESS;
export const REDDICKS_RESSOURCE_ADDRESS = CONFIG.REDDICKS_RESSOURCE_ADDRESS;
export const GBOF_RESOURCE_ADDRESS = CONFIG.GBOF_RESOURCE_ADDRESS;
export const CANDY_MACHINE_COMPONENT_ADDRESS = CONFIG.CANDY_MACHINE_COMPONENT_ADDRESS;
export const CANDY_MACHINE_BOT_BADGE_ADDRESS = CONFIG.CANDY_MACHINE_BOT_BADGE_ADDRESS;
export const CANDY_MACHINE_INTERNAL_USERS_KEY_VALUE_STORE = CONFIG.CANDY_MACHINE_INTERNAL_USERS_KEY_VALUE_STORE;
export const CANDY_MACHINE_CANDIES_RESOURCE_ADDRESS = CONFIG.CANDY_MACHINE_CANDIES_RESOURCE_ADDRESS;
export const CANDY_WRAPPER_COMPONENT_ADDRESS = CONFIG.CANDY_WRAPPER_COMPONENT_ADDRESS;
export const CANDY_WRAPPER_OWNER_BADGE_ADDRESS = CONFIG.CANDY_WRAPPER_OWNER_BADGE_ADDRESS;
export const CANDY_WRAPPER_PAIRS = CONFIG.CANDY_WRAPPER_PAIRS;
export const BATCH_CANDY_DISPENSER_COMPONENT_ADDRESS = CONFIG.BATCH_CANDY_DISPENSER_COMPONENT_ADDRESS;
export const BATCH_DCKSLAP_PER_BATCH = CONFIG.BATCH_DCKSLAP_PER_BATCH;
export const BATCH_REDDICKS_FEE_AMOUNT = CONFIG.BATCH_REDDICKS_FEE_AMOUNT;
export const BATCH_XRD_FEE_AMOUNT = CONFIG.BATCH_XRD_FEE_AMOUNT;
export const DCKSLAP_DAILY_WITHDRAWAL_LIMIT = 5;

